import * as theme from 'ls-common-client/dist/themes/default';

const colors = {
  grey: '#757575',
  green: '#40a499',
};

const backgroundImage = {
  blueGradient: 'linear-gradient(180deg,#98b0fd -45%,#2d60fb)',
};

const themeOverrides = {
  ...theme,
  backgroundImage,
  colors: {
    ...theme.colors,
    ...colors,
  },
  text: {
    ...theme.text,
    ...colors,
  },
  mediaQueries: {
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 1024px)',
    desktop: '(min-width: 1025px)',
  },
};

export default themeOverrides;
